import { validate } from 'validate.js';
import moment from 'moment';

import validationMessages from './validationMessages.jsx';

const constraints = {
  name: {
    presence: { message: validationMessages.name.presence },
    length: {
      maximum: 500,
      message: validationMessages.name.length
    }
  },
  description: {
    presence: false,
    length: {
      maximum: 10000,
      message: validationMessages.description.length
    }
  },
  participant: {
    presence: false,
    length: {
      maximum: 2000,
      message: validationMessages.participant.length
    }
  },
  eventLocation: {
    presence: { message: validationMessages.eventLocation.presence }
  },
  scope: {
    presence: { message: validationMessages.scope.presence }
  },
  executor: {
    presence: false,
    length: {
      maximum: 2000,
      message: validationMessages.executor.length
    }
  },
  contact_name: {
    presence: { message: validationMessages.contact_name.presence },
    length: {
      maximum: 2000,
      message: validationMessages.contact_name.length
    }
  },
  contact_email: {
    presence: { message: validationMessages.contact_email.presence }
  }
};
export default function validateInputs(form) {
  let errors =
    validate({
      name: form.name,
      description: form.description,
      participant: form.participant,
      eventLocation: form.lon,
      scope: form.scope,
      executor: form.executor,
      contact_email: form.contact_email,
      contact_name: form.contact_name,
      keywords: form.keywords
    }, constraints, { fullMessages: false });

  if (errors === undefined) errors = {};

  errors.links = validateLinks(form.links);
  if (form.contact_email !== undefined) errors.contact_email = validateEmails(form.contact_email);

  if (!moment(form.start_date, 'D.M.YYYY', true).isValid()) {
    errors.start_date = [validationMessages.start_date.presence];
  }
  if (!moment(form.end_date, 'D.M.YYYY', true).isValid()) {
    errors.end_date = [validationMessages.end_date.presence];
  }
  const start = moment(form.start_date, 'D.M.YYYY', true);
  const end = moment(form.end_date, 'D.M.YYYY', true);
  if (start.isAfter(end)) {
    errors.start_date = [validationMessages.start_date.startBeforeEnd];
    errors.end_date = [validationMessages.end_date.startBeforeEnd];
  }
  return errors;
}

function validateLinks(links) {
  for (let i = 0; i < links.length; i += 1) {
    if (links[i].url.length > 2000 || links[i].text.length > 2000) {
      return [validationMessages.link.length];
    }
  }
  return undefined;
}

function validateEmails(email) {
  const emails = email.replace(/ /g, '').split(',');
  if (emails.length === 1 && emails[0] === '') {
    return [validationMessages.contact_email.presence];
  }
  for (let i = 0; i < emails.length; i += 1) {
    const validateResult = validate({ contact_email: emails[i] }, {
      contact_email: { email: true } }
    );
    if (validateResult !== undefined) {
      if (emails[i] === '') return '';
      return [`${emails[i]} ${validationMessages.contact_email.notEmail}`];
    }
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/services/validationService.js